import React from "react";
import "./PaymentSection.css";
import CustomButton from "../../../../../components/customButton/CustomButton";

const PaymentSection = ({
  accNo,
  subTitle,
  children,
  showmodal,
  btnTitle,
  loading,
}) => {
  return (
    <div className="paymentsection-container">
      <div className="section-one">
        <div className="image-bg">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
          >
            <mask
              id="mask0_1207_11433"
              maskUnits="userSpaceOnUse"
              x="0"
              y="0"
              width="32"
              height="32"
            >
              <rect width="32" height="32" fill="#D9D9D9" />
            </mask>
            <g mask="url(#mask0_1207_11433)">
              <path
                d="M21.3336 18C21.9114 18 22.3892 17.8111 22.767 17.4333C23.1447 17.0556 23.3336 16.5778 23.3336 16C23.3336 15.4222 23.1447 14.9444 22.767 14.5667C22.3892 14.1889 21.9114 14 21.3336 14C20.7558 14 20.2781 14.1889 19.9003 14.5667C19.5225 14.9444 19.3336 15.4222 19.3336 16C19.3336 16.5778 19.5225 17.0556 19.9003 17.4333C20.2781 17.8111 20.7558 18 21.3336 18ZM7.07726 27.3333C6.40375 27.3333 5.83366 27.1 5.36699 26.6333C4.90033 26.1666 4.66699 25.5965 4.66699 24.923V7.07697C4.66699 6.40346 4.90033 5.83337 5.36699 5.3667C5.83366 4.90004 6.40375 4.6667 7.07726 4.6667H24.9233C25.5968 4.6667 26.1669 4.90004 26.6336 5.3667C27.1003 5.83337 27.3336 6.40346 27.3336 7.07697V10.7052H25.3336V7.07697C25.3336 6.9573 25.2952 6.859 25.2182 6.78207C25.1413 6.70514 25.043 6.66667 24.9233 6.66667H7.07726C6.95759 6.66667 6.85929 6.70514 6.78236 6.78207C6.70543 6.859 6.66696 6.9573 6.66696 7.07697V24.923C6.66696 25.0427 6.70543 25.141 6.78236 25.2179C6.85929 25.2949 6.95759 25.3333 7.07726 25.3333H24.9233C25.043 25.3333 25.1413 25.2949 25.2182 25.2179C25.2952 25.141 25.3336 25.0427 25.3336 24.923V21.2948H27.3336V24.923C27.3336 25.5965 27.1003 26.1666 26.6336 26.6333C26.1669 27.1 25.5968 27.3333 24.9233 27.3333H7.07726ZM17.7439 22C17.0704 22 16.5003 21.7666 16.0337 21.3C15.567 20.8333 15.3337 20.2632 15.3337 19.5897V12.4103C15.3337 11.7368 15.567 11.1667 16.0337 10.7C16.5003 10.2334 17.0704 10 17.7439 10H26.2567C26.9302 10 27.5003 10.2334 27.9669 10.7C28.4336 11.1667 28.6669 11.7368 28.6669 12.4103V19.5897C28.6669 20.2632 28.4336 20.8333 27.9669 21.3C27.5003 21.7666 26.9302 22 26.2567 22H17.7439ZM26.2567 20C26.3763 20 26.4746 19.9615 26.5516 19.8846C26.6285 19.8077 26.667 19.7094 26.667 19.5897V12.4103C26.667 12.2906 26.6285 12.1923 26.5516 12.1154C26.4746 12.0385 26.3763 12 26.2567 12H17.7439C17.6243 12 17.526 12.0385 17.449 12.1154C17.3721 12.1923 17.3336 12.2906 17.3336 12.4103V19.5897C17.3336 19.7094 17.3721 19.8077 17.449 19.8846C17.526 19.9615 17.6243 20 17.7439 20H26.2567Z"
                fill="#245293"
              />
            </g>
          </svg>
        </div>

        <div className="text-bg">
          {accNo ? (
            <div className="acc-no">
              <h6>{accNo}</h6>
            </div>
          ) : (
            <h5>Add a new bank account</h5>
          )}
          <p>{subTitle}</p>
        </div>
      </div>

      <div className="section-two">
        {children}
        <CustomButton
          loading={loading}
          customStyles={{
            width: "120px",
            height: "40px",
            marginTop: "0",
            fontSize: "14px",
            borderRadius: "5px",
          }}
          onClick={showmodal}
          title={btnTitle}
        />
      </div>
    </div>
  );
};

export default PaymentSection;
